import { render, staticRenderFns } from "./TeacherCourseList.vue?vue&type=template&id=56c381e4&scoped=true"
import script from "./TeacherCourseList.vue?vue&type=script&lang=js"
export * from "./TeacherCourseList.vue?vue&type=script&lang=js"
import style0 from "./TeacherCourseList.vue?vue&type=style&index=0&id=56c381e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c381e4",
  null
  
)

export default component.exports